import React, { useEffect, useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";

import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import FullWidthDiv from "../components/buttons/FullWidthDiv";

const Meretlap = () => {
	const { order, updateOrder, replaceOrder, resetOrder } = useOrder();

	const navigate = useStepNavigate();
	console.log("Rendelés adatok:", order);

	useEffect(() => {
		if (order.hmeliorder.hmeliorder_depot_szam < 1) {
			navigate("/MeretfelveteliHely");
		}
	}, [navigate]);

	return (
		<TablerLayout title="Várható méretlap szám">
			<div className="row justify-content-center">
				<div className="col-md-10 text-center mb-4">
					<FullWidthDiv height="200px" fontSize="auto">
						{order.hmeliorder.hmeliorder_specific_id}
					</FullWidthDiv>
				</div>
			</div>

			<StepperNavButton side="left" label="Vissza" onClick={() => navigate("/MeretfelveteliHely")} />

			<StepperNavButton side="right" label="Tovább" onClick={() => navigate("/RendelesTipus")} />
		</TablerLayout>
	);
};

export default Meretlap;
